<template>
  <div class="audio-player">
    <q-inner-loading
      v-if="isLoading"
      :showing="true"
    >
      <q-spinner-ios
        size="30px"
        color="primary"
      />
    </q-inner-loading>

    <q-media-player
      v-else
      id="bottomControls"
      bottom-controls
      :sources="sources"
      :hide-fullscreen-btn="true"
      type="video"
      ref="qmp"
      dense
      preload="none"
      background-color="white"
      color="primary"
      :style="controlWidth"
      @duration="setDuration"
      :disabled-seek="!duration"
    >
      <div
        v-if="!duration"
        slot="durationTime"
        class="q-media__controls--video-time-text text-primary"
      >
        <q-spinner-ios
          size="2.5em"
          color="primary"
          class="q-mx-xs"
        />
      </div>

      <div
        slot="settings"
        class="row items-center q-mr-xs q-ml-xs"
      >
        <q-btn
          flat
          icon="mdi-play-speed"
          color="primary"
          dense
          size="sm"
          v-if="url"
        >
          <q-tooltip>Velocidade</q-tooltip>
          <q-menu
            separate-close-popup
            dense
          >
            <q-list
              style="min-width: 100px"
              dense
            >
              <q-item
                clickable
                v-close-popup
              >
                <q-item-section @click="$refs.qmp.__playbackRateChanged(0.5)">
                  0,5x
                </q-item-section>
              </q-item>

              <q-item
                clickable
                v-close-popup
              >
                <q-item-section @click="$refs.qmp.__playbackRateChanged(1.0)">
                  1x
                </q-item-section>
              </q-item>

              <q-item
                clickable
                v-close-popup
              >
                <q-item-section @click="$refs.qmp.__playbackRateChanged(1.5)">
                  1,5x
                </q-item-section>
              </q-item>

              <q-item
                clickable
                v-close-popup
              >
                <q-item-section @click="$refs.qmp.__playbackRateChanged(2.0)">
                  2x
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-btn>

        <q-space v-if="url" />

        <q-btn
          v-if="url"
          @click="downloadAudio"
          flat
          dense
          size="sm"
          icon="mdi-download"
          color="primary"
        >
          <q-tooltip>Download do Arquivo</q-tooltip>
        </q-btn>

        <q-btn
          v-if="url && showTrashBtn"
          @click="handleDiscardRecord"
          flat
          dense
          size="sm"
          icon="mdi-delete"
          color="primary"
        >
          <q-tooltip>Descartar a gravação</q-tooltip>
        </q-btn>
      </div>
    </q-media-player>
  </div>
</template>

<script>
import { QMediaPlayer } from '@quasar/quasar-ui-qmediaplayer'
import { urlChecked, checkURL } from '@/libs/hasURL'
import Helpers from '@/libs/helpers'
import { download } from '@/components/player/utils.js'

export default {
  components: {
    QMediaPlayer
  },

  props: {
    url: {},
    name: {},
    mime: {},

    showTrashBtn: {
      type: Boolean,
      default: false
    },

    showLinkBtn: {
      type: Boolean,
      default: true
    },

    controlWidth: {
      default: 'width: 100%',
      type: String
    }
  },

  data () {
    return {
      isLoading: !urlChecked(this.url),
      duration: false
    }
  },

  computed: {
    sources () {
      return [{
        src: this.url,
        type: this.mime,
        name: this.name
      }]
    }
  },

  mounted () {
    this.isMounted = true
    checkURL(this, this.url)
  },

  beforeDestroy () {
    this.isMounted = false
  },

  methods: {
    downloadAudio () {
      download(this.url, this.name)
    },

    clipboard () {
      Helpers.copy(this, this.url, 'Link copiado!')
    },

    handleDiscardRecord () {
      this.$emit('handleDiscardRecord')
    },

    setDuration () {
      this.duration = true
    }
  }
}

</script>

<style lang="sass">
  .audio-player
    position: relative
    min-height: 35px
    width: 330px

    .q-media--player
      display: none

    .q-media--big-button
      display: none

    .q-menu .q-media
      width: 400px
      border-width: 0.1rem
      border-style: solid
      border-color: #065AA1
      .q-btn
        font-size: 10px

    .q-media__loading--video
      display: none

    #bottomControls .q-media__controls
      font-size: 12px

    .q-media__controls--button
      font-size: 12px !important

    .q-slider__track
      height: 2px !important

    .q-slider__thumb
      width: 14px !important
      height: 14px !important

    .q-media__controls--video-time-text svg:not(:root)
        width: 16px !important
</style>
